import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "@/components/base/SectionHeading";

export default function NewsSection() {
  return (
    <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
      <SectionHeading
        title="最新影视资讯"
        subtitle="及时了解剧集动态、上映消息与幕后故事"
      />
      <div className="bg-background-50 border border-background-200 rounded-lg divide-y divide-background-200">
        {newsList.slice(0, 6).map((n) => (
          <Link
            key={n.id}
            to={`/detail/${n.movieId}`}
            className="group flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 px-4 md:px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <span className="shrink-0 text-xs font-label text-foreground-400 sm:w-24">
              {n.date}
            </span>
            <div className="flex-1 min-w-0">
              <h3 className="font-medium text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                {n.title}
              </h3>
              <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-1">
                {n.summary}
              </p>
            </div>
            <i className="hidden sm:block ri-arrow-right-s-line text-xl text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}